import { Input } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import "./SearchBar.css"

const SearchBar = ({ query, onChange, animatedPlaceholder, previousPlaceholder, isAnimating }) => {
    return (
        <div className="row mt-2 mb-4 justify-content-center">
            <div className="col-12 d-flex justify-content-center">
                <div className={`search-input-wrapper ${isAnimating ? "animating" : ""}`}>
                    <Input allowClear className="home-search-input" placeholder="" value={query} prefix={<SearchOutlined style={{ color: "#9aa0a6" }} />} onChange={onChange} />
                    {!query && (
                        <>
                            {previousPlaceholder && isAnimating && <span className="search-placeholder prev">Cari aplikasi : {previousPlaceholder}</span>}
                            <span className="search-placeholder current">{animatedPlaceholder ? `Cari aplikasi : ${animatedPlaceholder}` : "Cari aplikasi : zoom, travel, fuel, hias, dll"}</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SearchBar
